import { render } from "./AiBodyStyles.vue?vue&type=template&id=7ab166b1&scoped=true"
import script from "./AiBodyStyles.vue?vue&type=script&lang=js"
export * from "./AiBodyStyles.vue?vue&type=script&lang=js"

import "./AiBodyStyles.vue?vue&type=style&index=0&id=7ab166b1&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab166b1"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiBodyStyles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ab166b1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ab166b1', __exports__)) {
    api.reload('7ab166b1', __exports__)
  }
  
  module.hot.accept("./AiBodyStyles.vue?vue&type=template&id=7ab166b1&scoped=true", () => {
    api.rerender('7ab166b1', render)
  })

}


export default __exports__